<template>
    <div>
        <el-row :gutter="30">
            <el-col :span="6" class="sidebar">
                <ListFilterComponent @setFilter="setFilter"
                                     :selectedFilters="filters.selected"
                                     :listFilters="filters.available">
                </ListFilterComponent>
                <router-link :to="{name: 'Add Widget', params: {type: type}}"
                             class="add-buttons"
                             :key="type"
                             v-for="(values, type) in types">
                    <el-button type="primary" class="fluid">widget {{ values && values.label }} <i
                            class="el-icon-plus"></i>
                    </el-button>
                </router-link>
            </el-col>
            <el-col class="box" :span="18">
                <div class="list__header">
                    <p class="list__title">
                        {{ getRouteName($route) }}
                    </p>
                    <search-list-form v-model="filters.selected.search"
                                      @submit="fetchData"/>
                </div>
                <el-table :data="data"
                          highlight-current-row
                          v-loading="listLoading"
                          class="list__table"
                          style="width: 100%;">
                    <el-table-column prop="id" label="id" width="80"></el-table-column>
                    <el-table-column label="typ">
                        <template slot-scope="scope" class="pull-right">
                            {{ types[scope.row.resourcetype] && types[scope.row.resourcetype].label }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="working_name" label="tytuł rob."></el-table-column>
                    <el-table-column prop="name_pl" label="nazwa (pl)"></el-table-column>
                    <el-table-column prop="name_en" label="nazwa (en)"></el-table-column>
                    <el-table-column label="opcje" width="150" class="pull-right">
                        <template slot-scope="scope" class="pull-right">
                            <router-link :to="{name: 'Edit Widget', params: {id: scope.row.id}}">
                                <el-button size="small" :title="$t('edit')">
                                    <i class="el-icon-edit"></i>
                                </el-button>
                            </router-link>
                            <el-button type="danger"
                                       size="small"
                                       :title="$t('delete')"
                                       @click="handleDelete(scope.$index, scope.row)"><i
                                    class="el-icon-delete"></i>
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-col :span="24" class="list__pagination">
                    <el-pagination layout="prev, pager, next"
                                   @current-change="handlePageChange"
                                   :page-size="pageSize" :total="count">
                    </el-pagination>
                </el-col>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import {Widget} from '@/api/';
    import ListFilterComponent from '@/components/ListFilterComponent'

    export default {
        data () {
            return {
                filters: {
                    available: [],
                    selected: {}
                },
                pageSize: 0,
                count: 0,
                types: {},
                data: [],
                listLoading: false,
                service: Widget
            }
        },
        methods: {
            handlePageChange (val) {
                this.page = val;
                this.fetchData();
            },
            setFilter (filter) {
                this.page = 1
                const key = filter.query_param
                const value = filter.value
                this.$set(this.filters.selected, key, value)
                this.fetchData()
            },
            addTypesFilter () {
                this.service.types({global: true}).then(response => {
                    this.types = response.data;
                    const typesFilters = []
                    Object.keys(this.types).forEach(key => {
                        typesFilters.push({
                            'label': this.types[key].label,
                            'value': this.types[key].polymorphic_ctype
                        })
                    })
                    const options = [
                        {label: 'Wszystkie', value: ''},
                        ...typesFilters
                    ]
                    this.filters.available.push({
                        name: 'Typ widgetu',
                        query_param: 'polymorphic_ctype',
                        options: options
                    })
                    this.setFilter({query_param: 'polymorphic_ctype', value: ''})
                })
            },
            fetchData () {
                let params = {
                    page: this.page,
                    ...this.filters.selected,
                    global_scope: true
                };
                this.listLoading = true;
                this.service.fetch({}, {params}).then(response => {
                    this.data = response.data.results;
                    this.count = response.data.count;
                    this.pageSize = response.data.page_size;
                    this.listLoading = false;
                })
            },
            async handleDelete (index, row) {
                await this.$confirm(this.$i18n.t('deleteConfirmation'), this.$i18n.t('delete'), {
                    type: 'warning'
                })

                this.listLoading = true;
                await this.service.delete(row.id)

                this.listLoading = false;
                this.$message({
                    message: 'Element został usunięty',
                    type: 'success'
                })

                this.fetchData()
            }
        },
        mounted () {
            this.fetchData();
            this.addTypesFilter()
        },
        components: {
            ListFilterComponent
        }
    }
</script>
<style lang="scss" scoped>
    .add-buttons {
        display: block;
        margin-bottom: 10px;
    }
</style>



// WEBPACK FOOTER //
// WidgetsList.vue?4a3349ab